// src/components/account/SectionCard.jsx
export default function SectionCard({ title, subtitle, action, children, className = "" }) {
  return (
    <section
      className={[
        "rounded-2xl border p-2 sm:p-4",
        "border-neutral-200 bg-white",
        "dark:border-neutral-800 dark:bg-neutral-900",
        className,
      ].join(" ")}
    >
      <div className="mb-2 sm:mb-3">
        <div className="flex items-center justify-between gap-2">
          <div className="text-sm font-semibold text-neutral-900 dark:text-neutral-50">
            {title}
          </div>
          {action ? <div>{action}</div> : null}
        </div>

        {subtitle ? (
          <div className="mt-1 text-xs text-neutral-500 dark:text-neutral-400">
            {subtitle}
          </div>
        ) : null}
      </div>

      {children}
    </section>
  );
}
